import { PackageType } from '../../types';
import { usePackageConfiguration } from '../../contexts';
import { MultiDayExperiencesTimeslotsStep } from './MultiDayExperiencesStep/MultiDayExperiencesTimeslotsStep';
import { RepeatingExperiencesTimeslotsStep } from './RepeatingExperiencesStep/RepeatingExperiencesTimeslotsStep';

/**
 * ExperiencesStep Router
 *
 * Determines which experiences flow to render based on package type:
 * - Flexible packages (numberOfNights > 1): Fixed day experiences
 * - Repeating packages (numberOfNights === 1): Day 0/1 distribution
 */
export const ExperiencesStep = () => {
  const { packageType } = usePackageConfiguration();

  return packageType === PackageType.REPEATING ? (
    <RepeatingExperiencesTimeslotsStep />
  ) : (
    <MultiDayExperiencesTimeslotsStep />
  );
};
